import { isEdge } from 'react-device-detect';

import { ENV, IS_PROD } from '../../utils';

/**
 * useBI2Redirect hook
 *
 * This hook is used to open a new browser tab with a specified BI2 URL. The URL is prefixed based on the current environment and the user's browser.
 *
 * @returns {(bi2Url: string) => void} - A function that takes a BI2 URL and opens it in a new browser tab.
 *
 * @example
 * const handleOrderClick = useBI2Redirect();
 * handleOrderClick('/path/to/resource');
 *
 * // In this example, when handleOrderClick is called, a new browser tab is opened with the URL 'https://bi2con[env].bestseller.com/path/to/resource', where [env] is the current environment suffix (or '' if the environment is 'prod'). If the user's browser is not Edge, the URL is prefixed with 'microsoft-edge:'.
 */
export const useBI2Redirect =
    (): ((bi2Url: string) => void) => (bi2Url: string) => {
        const envSuffix = IS_PROD ? '' : ENV;
        const edgePrefix = !isEdge ? 'microsoft-edge:' : '';

        window.open(
            `${edgePrefix}https://bi2con${envSuffix}.bestseller.com${bi2Url}`,
            '_blank'
        );
    };
